import * as Yup from "yup";

const AddProductSchema = [
  {
    key: "1",
    label: "Product Name",
    name: "name",
    validationSchema: Yup.string()
      .required("Name is Required")
      .max(20, "Name Can Not Be More Than 20 Characters"),
    type: "text",
    initialValue: "",
  },
  {
    key: "2",
    label: "Product Title",
    name: "title",
    validationSchema: Yup.string()
      .required("Title is Required")
      .max(50, "Title Can Not Be More Than 50 Characters"),
    type: "text",
    initialValue: "",
  },

  {
    key: "3",
    label: "Price",
    name: "price",
    validationSchema: Yup.number().required("Price is Required"),
    type: "number",
    initialValue: "",
  },
  {
    key: "4",
    label: "Discount (%) ",
    name: "discount",
    validationSchema: Yup.number(),
    type: "number",
    initialValue: "",
  },
  {
    key: "5",
    label: " Available Stock",
    name: "quantity",
    validationSchema: Yup.number().required("Quantity is Required"),
    type: "number",
    initialValue: "",
  },
  {
    key: "6",
    label: "Quantity of water  (ml)",
    name: "waterQuantity",
    validationSchema: Yup.number().required("Water Quantity is Required"),
    type: "number",
    initialValue: "",
  },
  {
    key: "7",
    label: "Supplier",
    name: "supplierId",
    validationSchema: Yup.string().required("Supplier is Required"),
    type: "select",
    initialValue: "",
  },

  {
    key: "10",
    label: "Order Type",
    name: "orderType",
    validationSchema: Yup.string().required("Order Type is Required"),
    type: "select",
    initialValue: "",
  },
  {
    key: "12",
    label: "Add To Feature Product",
    name: "featured",
    validationSchema: Yup.string(),
    type: "select",
    initialValue: false,
  },
  {
    key: "8",
    label: "Images",
    name: "images",
    validationSchema: Yup.array().required("Images is Required"),
    type: "file",
    initialValue: [],
  },
  {
    key: "9",
    label: "Short Description",
    name: "shortDesc",
    validationSchema: Yup.string()
      .required("Short Description is Required")
      .max(300, "Short Description Can Not Be More Than 300 Characters"),
    type: "textarea",
    initialValue: "",
    multiline: true,
    rows: 3,
  },
  {
    key: "11",
    label: "Product Description",
    name: "description",
    validationSchema: Yup.string().required("Description is Required"),
    type: "textarea",
    initialValue: "",
    multiline: true,
    rows: 5,
  },
];

export default AddProductSchema;
